import React from 'react';
import Reflux from 'reflux';
import {Button, Col, Row, Input, Select, Table, Modal, message, InputNumber, Card, Tooltip} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab} from '../../components';
import {openNotice, toFixed2} from 'Utils';
import {checkPhone} from '../../utils/regexp';
import {
    purchaseUnit,
    returnSubbank,
    returnAddress,
    fetchOrders,
    details,
    submitDetails,
    fetchOrderDetail
} from '../../service/returnGoods';
import {getReportType} from '../../service/reportForm';

const confirm = Modal.confirm;

class BusinessAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            channelCode: window.sessionStorage.getItem('cur_channelId'),
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            opts: ['退货'],
            key: 0,
            selectedRowsAll: {},
            selectedRowKeys: [],
            selectedRowKeys1: [],
            selectedRowsAllKeys: [],
            orders: [],
            total: 0,
            searchObj: {
                objCode: '',
                objDescription: '',
                middleCat: '',
                stockCode: '',
                orderCode: '',
                lineId: '',
                s: 10,
                p: 1
            },
            formData: {
                contactNumber: '',
                purchaseUnit: '',
                returnSubbank: '',
                returnAddress: '',
                returnRelatedTypes: '',
                curArturnAmount: 0,
                returnNumber: 0,
                returnReason: '',
                taxRate: '',
                gobackCount: 0,
                actualReturnAmount: '',
                id: '',
                orderNumber: '',
                returnDetailType: ''
            },
            addRows: [],
            categoryData: [],
            visible: false,
            purchaseUnitList: [],
            returnSubbankList: [],
            returnAddressList: [],
            returnReasonList: [],
            details: {
                // cusNumber: '',
                // cusName: '',
                // yearRrturnAmount: '',
                // yearGobackAmount: '',
                // contractType: '',
            },
            canSub: true,
            canSave: true,
            confirmvisible: false,
            confirmLoading: false,
            loading: false,
            returnDetailTypes: [{"text": "积压退货"}, {"text": "清账退货"}, {"text": "重新开单"}]
        };
        this.returnRelatedTypesList = [
            {
                id: 'A',
                text: '未开票退换货处理',
                flag: false,
                isDisabled: false
            }, {
                id: 'B',
                text: '已开票-红字证明单',
                flag: true,
                isDisabled: false
            }, {
                id: 'D',
                text: '已开票-回购',
                flag: true,
                isDisabled: true
            }];
        this.taxRateOptions = [
            {
                id: '16',
                text: '16%',
            }, {
                id: '17',
                text: '17%',
            }, {
                id: '13',
                text: '13%',
            }
        ];
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    };

    getPurchaseUnit = (param, flag) => {
        purchaseUnit(param).then(res => {
            if (res && res.code === 200) {
                if (this._isMounted) {
                    const data = res.data || [];
                    this.setState({
                        purchaseUnitList: data,
                    });
                    if (flag) {
                        this.setState({
                            // formData: { ...this.state.formData, purchaseUnit: data[0] && data[0].id.toString() },
                            formData: {...this.state.formData, purchaseUnit: ''},
                            details: {...this.state.details, contractType: data[0] && data[0].contractType}
                        });
                    }
                }
            }
        });
    };
    getReturnSubbank = (param, flag) => {
        returnSubbank(param).then(res => {
            if (res && res.code === 200) {
                if (this._isMounted) {
                    const data = res.data || [];
                    this.setState({
                        returnSubbankList: data,
                    });
                    if (flag) {
                        this.setState({
                            // formData: { ...this.state.formData, returnSubbank: data[0] && data[0].id.toString() }
                            formData: {...this.state.formData, returnSubbank: ''}
                        });
                    }
                }
            }
        });
    };
    getReturnAddress = (flag) => {
        returnAddress().then(res => {
            if (res && res.code === 200) {
                if (this._isMounted) {
                    const data = res.data || [];
                    this.setState({
                        returnAddressList: data,
                    });
                    if (flag) {
                        this.setState({
                            // formData: { ...this.state.formData, returnAddress: data[0] && data[0].gobackAddressId.toString() }
                            formData: {...this.state.formData, returnAddress: ''}
                        });
                    }
                }
            }
        });
    };

    changeInput(e) {
        this.state.formData[e.target.name] = e.target.value;
        this.setState({
            formData: this.state.formData
        });
    }

    changeSelect(value, type) {
        const {formData, purchaseUnitList, details} = this.state;
        const self = this;

        if (type === 'returnRelatedTypes') {
            if (formData.returnRelatedTypes && formData.returnRelatedTypes != '') {
                if (((formData.returnRelatedTypes == 'B' || formData.returnRelatedTypes == 'D') && value == 'A') || (formData.returnRelatedTypes == 'A' && value == 'B') || (formData.returnRelatedTypes == 'A' && value == 'D')) {
                    confirm({
                        title: '选择退货相关类型将重置物料信息,确定吗?',
                        //content: 'Some descriptions',
                        okText: '确定',
                        // okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            // self.setState({});
                            self.setState({
                                formData: {...self.state.formData, [type]: value}
                            });
                            let prevFlag;
                            let nextFlag;
                            self.returnRelatedTypesList.forEach(item => {
                                if (item.id === formData.returnRelatedTypes) {
                                    prevFlag = item.flag;
                                }
                                if (item.id === value) {
                                    nextFlag = item.flag;
                                }
                            });
                            if (prevFlag !== nextFlag) {
                                self.setState({
                                    orders: [],
                                    selectedRowsAllKeys: []
                                });
                            }
                            if (formData[type] !== value) {
                                self.setState({
                                    formData: {...self.state.formData, [type]: value}
                                });
                                self.setState({
                                    orders: [],
                                    selectedRowsAllKeys: []
                                });
                            }
                        },
                        onCancel() {
                            return
                        },
                    });
                } else {
                    self.setState({
                        formData: {...self.state.formData, [type]: value}
                    });
                }
            } else {
                self.setState({
                    formData: {...self.state.formData, [type]: value}
                });
                let prevFlag;
                let nextFlag;
                self.returnRelatedTypesList.forEach(item => {
                    if (item.id === formData.returnRelatedTypes) {
                        prevFlag = item.flag;
                    }
                    if (item.id === value) {
                        nextFlag = item.flag;
                    }
                });
                if (prevFlag !== nextFlag) {
                    self.setState({
                        orders: [],
                        selectedRowsAllKeys: []
                    });
                }
            }
        } else {
            if (type === 'purchaseUnit') {
                if (formData.purchaseUnit && formData.purchaseUnit != '') {
                    confirm({
                        title: '选择退货相关类型将重置物料信息,确定吗?',
                        //content: 'Some descriptions',
                        okText: '确定',
                        // okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            self.setState({
                                formData: {...self.state.formData, [type]: value}
                            });
                            const contractTypeObj = purchaseUnitList.filter(item => item.id === ~~value)[0];
                            self.setState({
                                details: {...details, contractType: contractTypeObj.contractType}
                            });
                            if (formData[type] !== value) {
                                self.setState({
                                    formData: {...self.state.formData, [type]: value}
                                });
                                self.setState({
                                    orders: [],
                                    selectedRowsAllKeys: []
                                });
                            }
                        },
                        onCancel() {
                            return
                        },
                    });
                } else {
                    self.setState({
                        formData: {...self.state.formData, [type]: value}
                    });
                    const contractTypeObj = purchaseUnitList.filter(item => item.id === ~~value)[0];
                    self.setState({
                        details: {...details, contractType: contractTypeObj.contractType}
                    });
                }
            }
            // if (formData[type] !== value) {
            //   self.setState({
            //     formData: { ...self.state.formData, [type]: value }
            //   });
            //   self.setState({
            //     orders: [],
            //     selectedRowsAllKeys: []
            //   });
            // }
            if (type == 'taxRate') {
                if (formData.taxRate && formData.taxRate != '') {
                    confirm({
                        title: '选择税率将重置物料信息,确定吗?',
                        //content: 'Some descriptions',
                        okText: '确定',
                        // okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            self.setState({
                                formData: {...self.state.formData, [type]: value},
                                orders: [],
                                selectedRowsAllKeys: []
                            });
                        },
                        onCancel() {
                            return
                        },
                    });
                } else {
                    self.setState({
                        formData: {...self.state.formData, [type]: value},
                    })
                }
            }

            if (type == 'returnAddress') {
                // if (formData.returnAddress && formData.returnAddress != '') {
                //     confirm({
                //         title: '选择退货地点将重置物料信息,确定吗?',
                //         //content: 'Some descriptions',
                //         okText: '确定',
                //         // okType: 'danger',
                //         cancelText: '取消',
                //         onOk() {
                //             self.setState({
                //                 formData: {...self.state.formData, [type]: value},
                //                 orders: [],
                //                 selectedRowsAllKeys: []
                //             });
                //         },
                //         onCancel() {
                //             return
                //         },
                //     });
                // } else {
                self.setState({
                    formData: {...self.state.formData, [type]: value},
                })
                //}
            }

            if (type == 'returnSubbank') {
                // if (formData.returnSubbank && formData.returnSubbank != '') {
                //     confirm({
                //         title: '选择退货子库将重置物料信息,确定吗?',
                //         //content: 'Some descriptions',
                //         okText: '确定',
                //         // okType: 'danger',
                //         cancelText: '取消',
                //         onOk() {
                //             self.setState({
                //                 formData: {...self.state.formData, [type]: value},
                //                 orders: [],
                //                 selectedRowsAllKeys: []
                //             });
                //         },
                //         onCancel() {
                //             return
                //         },
                //     });
                // } else {
                self.setState({
                    formData: {...self.state.formData, [type]: value},
                })
                //}
            }
            if (type == 'returnReason') {
                self.setState({
                    formData: {...self.state.formData, [type]: value},
                });
            }
            if (type === 'returnDetailType') {
                self.setState({
                    formData: {...self.state.formData, [type]: value},
                });
            }
        }
    };

    handleOk = () => {
        const {selectedRowsAll} = this.state;
        const arr = Object.values(selectedRowsAll).reduce((prev, current) => prev.concat(current), []);
        const selected = [];
        arr.forEach(item => {
            selected.push(item.lineId);
        });
        this.setState({
            orders: [...this.state.orders, ...arr],
            selectedRowsAllKeys: [...this.state.selectedRowsAllKeys, ...selected],
            selectedRowKeys1: [],
            selectedRowKeys: []
        });
        this.handleCancel();
    };
    handleCancel = () => {
        this.setState({
            searchObj: {
                objCode: '',
                objDescription: '',
                middleCat: '',
                stockCode: '',
                orderCode: '',
                lineId: '',
                s: 10,
                p: this.state.searchObj.p
            },
            visible: false
        });
    };

    goView(url) {
        hashHistory.push(url);
    };

    goBack() {
        hashHistory.goBack();
    };

    pageChange(page) {
        this.setState({searchObj: {...this.state.searchObj, p: page}}, () => {
            this.getOrderList();
        });
    }

    getEditDetails = (id) => {
        const self = this;
        const {formData} = this.state;
        fetchOrderDetail({id}).then(res => {
            if (res && res.code == 200) {
                const data = res.data;
                this.setState({
                    formData: {
                        ...formData,
                        endCustomer: data.endCustomer,
                        contactNumber: data.phone,
                        purchaseUnit: data.purchaseId ? data.purchaseId.toString() : '',
                        returnSubbank: data.gobackStockId ? data.gobackStockId.toString() : '',
                        returnAddress: data.gobackAddressId ? data.gobackAddressId.toString() : '',
                        returnNumber: data.gobackCount,
                        taxRate: data.taxCode ? data.taxCode.toString() : '',
                        returnReason: data.returnReason ? data.returnReason.toString() : '',
                        actualReturnAmount: data.actualReturnAmount,
                        orderNumber: data.orderNumber,
                        id: data.id,
                        returnRelatedTypes: data.returnType,
                        curArturnAmount: data.curArturnAmount,
                        returnDetailType: data.returnDetailType
                    },
                    details: {
                        ...self.state.details,
                        contractType: data.contractType,
                    },
                    orders: data.lineList || []
                });
                this.state.orders.forEach(item => {
                    this.setState({selectedRowsAllKeys: [...this.state.selectedRowsAllKeys, item.lineId]})
                })
            }
        }).then(() => {
            this.getPurchaseUnit({
                channelCode: this.state.channelCode
            }, false);
            this.getReturnSubbank({removeFlag: 0, p: 1, s: 1000}, false);
            this.getReturnAddress(false);
            this.getReturnReason(false);
        });
    };

    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        this._isMounted = true;
    }

    componentDidMount() {
        const id = this.props.params.id;
        this.getDetails();
        if (id) {
            this.getEditDetails(id);
        } else {
            this.getPurchaseUnit({
                channelCode: this.state.channelCode
            }, true);
            this.getReturnSubbank({removeFlag: 0, p: 1, s: 1000}, true);
            this.getReturnAddress(true);
            this.getReturnReason(true);
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getReturnReason = (flag) => {
        getReportType({
            sKey: 'ORDER_GOBACK_REASON'
        }).then(res => {
            if (res.code === 200) {
                const data = res.data;
                this.setState({
                    returnReasonList: data,
                });
                if (flag) {
                    this.setState({
                        formData: {...this.state.formData, returnReason: data[0] && data[0].sKey}
                    });
                }
            }
        });
    };

    getDetails = () => {
        var self = this;
        details().then(res => {
            if (res.code === 200) {
                const data = res.data || {};
                const dataMap = res.dataMap || {};
                // debugger
                self.setState({
                    details: {
                        ...self.state.details,
                        cusNumber: data.code,
                        cusName: data.name,
                        yearRrturnAmount: dataMap.yearRrturnAmount,
                        yearGobackAmount: dataMap.yearGobackAmount,
                        // curArturnAmount: dataMap.curArturnAmount
                    }
                });
            }
        });
    };
    // 新增行
    addHandler = () => {
        /*if (!this.state.formData.taxRate || this.state.formData.taxRate == '') {
            openNotice('warning', '请选择税率');
            return
        }*/
        if (!this.state.formData.returnRelatedTypes || this.state.formData.returnRelatedTypes == '') {
            openNotice('warning', '请选择退货相关类型');
            return
        }
        if (!this.state.formData.purchaseUnit || this.state.formData.purchaseUnit == '') {
            openNotice('warning', '请选择购货单位');
            return
        }
        if (!this.state.formData.returnAddress || this.state.formData.returnAddress == '') {
            openNotice('warning', '请选择退货地点');
            return
        }
        if (!this.state.formData.returnSubbank || this.state.formData.returnSubbank == '') {
            openNotice('warning', '请选择退货子库');
            return
        }

        this.setState({
            visible: true,
            addRows: [],
            total: 0
        });
        // this.getOrderList();
    };
    deleteHandler = () => {
        const {orders, selectedRowKeys, formData} = this.state;
        const arr = orders.filter(item => !selectedRowKeys.includes(item.lineId));
        const selected = [];
        let num = 0;
        let curArturnAmount = 0;
        let actualReturnAmount = 0;
        arr.forEach(item => {
            selected.push(item.lineId);
            num += item.gobackCount;
            curArturnAmount += item.sellMoney;
            actualReturnAmount += item.sellMoney;
        });
        formData.curArturnAmount = Math.round(curArturnAmount * 100) / 100;
        formData.actualReturnAmount = Math.round(actualReturnAmount * 100) / 100;
        formData.returnNumber = num;
        this.setState({
            orders: arr,
            selectedRowsAllKeys: [...selected],
            formData: {...formData}
        });
    };
    searchOrderList = () => {
        this.setState({
            searchObj: {...this.state.searchObj, p: 1},
            loading: true
        }, () => {
            this.getOrderList();
        });
    };
    getOrderList = () => {
        const {formData, searchObj} = this.state;
        fetchOrders({
            taxCode: formData.taxRate,
            returnRelatedType: formData.returnRelatedTypes,
            channelCode: window.sessionStorage.getItem('cur_channelId'),
            purchaseId: ~~formData.purchaseUnit,
            ...searchObj,
        }).then(result => {
            if (result.status && result.code == 200) {
                this._isMounted && this.setState({
                    addRows: result.data,
                    total: result.total,
                    loading: false
                });
            } else {
                message.error(result.message);
            }
        });
    };

    changeSearchObj(e, name) {
        this.state.searchObj[name] = e.target.value;
        this.setState({
            searchObj: this.state.searchObj
        });
    };

    goUpdateGobackCount = (value, record) => {
        // if (!~~value) return;
        const {orders, formData} = this.state;
        let num = 0;
        let actualReturnAmount = 0;
        orders.forEach(item => {
            item.amount = item.amount || 0;
            if (item.lineId === record.lineId) {
                //退货数量
                item.gobackCount = ~~value;
                //销售金额
                //
                item.sellMoney = value * item.sellPrice;
                //折扣后金额
                item.discountMoney = value * item.discountPrice;
            }
            actualReturnAmount += item.sellMoney;
            num += item.gobackCount;
        });
        //实际退货金额和本次退货金额一致，都取牌价*退货数量
        formData.curArturnAmount = Math.round(actualReturnAmount * 100) / 100;
        formData.actualReturnAmount = Math.round(actualReturnAmount * 100) / 100;
        formData.returnNumber = num;
        this.setState({
            formData: formData,
            orders: [...this.state.orders]
        });
    };

    goUpdateRemark = (e, record) => {
        this.state.orders.forEach(item => {
            if (item.lineId === record.lineId) {
                item.remark = e.target.value;
            }
        });
        this.setState({
            orders: [...this.state.orders]
        });
    };

    addSave(record) {
        const {selectedRowsAllKeys, orders, selectedRowKeys1, selectedRowsAll, searchObj} = this.state;
        if (selectedRowsAllKeys.includes(record.lineId)) {
            openNotice('warning', '物料已添加');
            return
        }
        const arr1 = selectedRowKeys1.filter(item => item !== record.lineId);
        let arr2 = [];
        if (selectedRowsAll[searchObj.p]) {
            arr2 = selectedRowsAll[searchObj.p].filter(item => item.lineId !== record.lineId);
        }
        selectedRowsAll[searchObj.p] = arr2;
        this.setState({
            selectedRowKeys1: [...arr1],
            selectedRowsAll: {...selectedRowsAll},
            selectedRowsAllKeys: [...selectedRowsAllKeys, record.lineId],
            orders: [...orders, record]
        })
    }

    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    }
    handleCancel5 = () => {
        this.setState({
            confirmvisible: false,
            confirmLoading: false,
        });
    }


    submitHandler = (type) => {
        this.setState({confirmLoading: true});
        const {formData, details, purchaseUnitList, orders, returnSubbankList, returnAddressList} = this.state;
        let canSubimt = true;
        /*checkPhone(null, formData.contactNumber, (msg) => {
            if (msg) {
                openNotice('error', '提示', msg);
            } else {*/
        if (orders.length == 0) {
            openNotice('error', '提示', '必须选择退货物料');
            this.setState({confirmvisible: false, confirmLoading: false});
            return false;
        }

        if (formData.returnDetailType == '') {
            openNotice('error', '提示', '退货细分类型必选');
            this.setState({confirmvisible: false, confirmLoading: false});
            return false;
        }
        canSubimt = orders.every(item => !!item.gobackCount);
        this.setState({
            canSave: false
        });
        if (canSubimt) {
            if (type === 'sub') {
                this.setState({
                    canSub: false
                });
            }
            const id = this.props.params.id;
            const param = {
                saveSub: type,
                qualityBusiness: 'B',
                gobackCount: formData.returnNumber,
                curArturnAmount: formData.curArturnAmount,
                channelCode: window.sessionStorage.getItem('cur_channelId'),
                returnType: formData.returnRelatedTypes,
                returnTypeName: this.returnRelatedTypesList.filter(item => item.id === formData.returnRelatedTypes)[0].text,
                returnReason: formData.returnReason,
                cusNumber: details.cusNumber,
                cusName: details.cusName,
                endCustomer: formData.endCustomer,
                contractType: details.contractType,
                taxCode: formData.taxRate,
                yearArturnAmount: details.yearRrturnAmount,
                yearGobackAmount: details.yearGobackAmount,
                purchaseId: ~~formData.purchaseUnit,
                purchaseName: purchaseUnitList.filter(item => item.id === ~~formData.purchaseUnit)[0].name,
                phone: formData.contactNumber,
                gobackAddressId: ~~formData.returnAddress,
                gobackAddress: returnAddressList.filter(item => item.gobackAddressId === ~~formData.returnAddress)[0].gobackAddress,
                gobackStockId: formData.returnSubbank,
                gobackStockeName: returnSubbankList.filter(item => item.id === ~~formData.returnSubbank)[0].subStoreName,
                actualReturnAmount: formData.actualReturnAmount,
                id: formData.id,
                orderNumber: formData.orderNumber,
                returnDetailType: formData.returnDetailType,
                lineList: orders
            };
            if (id) {
                param.id = id;
            }
            submitDetails(param).then(res => {
                if (res.status) {
                    openNotice('success', '提示', (res && res.message) ? res.message : '操作成功');
                    this.setState({confirmvisible: false, confirmLoading: false});
                    this.goBack();
                } else {
                    openNotice('error', '提示', (res && res.message) ? res.message : '操作成功');
                    this.setState({confirmvisible: false, confirmLoading: false});
                    this.setState({
                        canSave: true,
                        canSub: true
                    });
                }
            });
        } else {
            this.setState({
                canSave: true,
                canSub: true
            });
            openNotice('error', '提示', '请填写退货数量');
            this.setState({confirmvisible: false, confirmLoading: false});
        }
        /*  }
      });*/
    };

    render() {
        const {
            opts,
            key,
            formData,
            canSub,
            canSave,
            total,
            details,
            searchObj,
            orders,
            visible,
            addRows,
            purchaseUnitList,
            returnSubbankList,
            returnAddressList,
            selectedRowsAll,
            returnReasonList,
            returnStatusList,
            confirmLoading,
            confirmvisible,
            loading,
            button_limits_end,
            returnDetailTypes
        } = this.state;
        const tableViewProps = {
            rowKey: 'lineId',
            scroll: {x: 2000, y: false},
            columns: [{
                title: '序号',
                dataIndex: 'lineId'
            }, {
                title: '渠道',
                dataIndex: 'channelName'
            }, {
                title: '产品线',
                dataIndex: 'productLineName'
            }, {
                title: '物料编码',
                dataIndex: 'objCode'
            }, {
                title: '物料描述',
                dataIndex: 'objDescription'
            }, {
                title: '生产公司',
                dataIndex: 'factoryName'
            }, {
                title: '属性',
                dataIndex: 'property'
            }, {
                title: '单位',
                dataIndex: 'unit'
            }, {
                title: '牌价',
                dataIndex: 'brandPrice'
            }, {
                title: '销售单价',
                dataIndex: 'sellPrice',
                render: (text, record, index) => <span>{record.sellPrice}</span>
            }, {
                title: '退货数量',
                dataIndex: 'gobackCount',
                render: (text, record, index) => (
                    <InputNumber
                        style={{width: 80}}
                        min={0}
                        max={record.quantity}
                        value={record.gobackCount}
                        onChange={(value) => {
                            this.goUpdateGobackCount(value, record)
                        }}
                    />
                )
            }, {
                title: '可用数量',
                dataIndex: 'quantity'
            }, {
                title: '销售金额',
                dataIndex: 'sellMoney',
                render: (text, record, index) => {
                    return <span>{Math.round(record.sellMoney * 100) / 100}</span>
                }
            }, {
                title: '原出库单号',
                dataIndex: 'stockCode'
            }, {
                title: '原订单号',
                dataIndex: 'orderCode'
            }, {
                title: '原订单折扣率',
                dataIndex: 'discount'
            }, {
                title: '税率',
                dataIndex: 'taxCode'
            }, {
                title: '折扣后单价',
                dataIndex: 'discountPrice',
                render: (text, record, index) =>
                    <span>{record.discountPrice ? record.discountPrice : record.sellPrice}</span>
            }, {
                title: '折扣后金额',
                dataIndex: 'discountMoney',
                render: (text, record, index) => <span>{Math.round(record.discountMoney * 100) / 100}</span>
            }, {
                title: '备注',
                dataIndex: 'remark',
                render: (text, record, index) => (
                    <Input
                        value={record.remark}
                        onChange={(e) => {
                            this.goUpdateRemark(e, record)
                        }}
                    />
                )
            }],
            dataSource: orders
        };
        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                });
            }
        };
        const rowSelection1 = {
            selectedRowKeys: this.state.selectedRowKeys1,
            onChange: (selectedRowKeys, selectedRows) => {
                selectedRowsAll[searchObj.p] = selectedRows;
                this.setState({
                    selectedRowsAll: selectedRowsAll,
                    selectedRowKeys1: selectedRowKeys
                });
            },
            getCheckboxProps: record => ({
                disabled: this.state.selectedRowsAllKeys.includes(record.lineId)
            })
        };
        const addProps = {
            rowKey: 'lineId',
            loading: loading,
            columns: [{
                title: '物料编码',
                dataIndex: 'objCode'
            }, {
                title: '物料名称',
                dataIndex: 'objDescription'
            }, {
                title: '中类',
                dataIndex: 'middleCat'
            }, {
                title: '出库单号',
                dataIndex: 'stockCode'
            }, {
                title: '出库日期',
                dataIndex: 'confirmDate'
            }, {
                title: '订单号',
                dataIndex: 'orderCode'
            }, {
                title: '税率',
                dataIndex: 'taxCode'
            }, {
                title: '可用数量',
                dataIndex: 'quantity'
            }, {
                title: '销售单价',
                dataIndex: 'sellPrice',
                render: (text, record, index) => <span>{Math.round(record.sellPrice * 100) / 100}</span>
            }, {
                title: '发票信息',
                dataIndex: 'invoiceContent'
            }, {
                title: '成套项目编码',
                dataIndex: 'ctNumber'
            }, {
                title: '操作',
                dataIndex: 'save',
                width: 100,
                render: (text, record, index) => (
                    <Button style={{background: '#red'}} icon="plus"
                            onClick={this.addSave.bind(this, record)}>添加</Button>)
            }],
            dataSource: addRows
        };
        const pagination = {
            total: total,
            current: searchObj.p,
            defaultCurrent: searchObj.p,
            pageSize: searchObj.s,
            onChange: this.pageChange
        };
        return (
            <div className="dms-main-box">
                <div className="Card-P">
                    <DmsTab options={opts} defaultKey={key}>
                        {button_limits_end.returnGoodsCommit &&
                            <Button onClick={this.showModal} disabled={!canSub}>提交</Button>}
                        <Modal title="注意"
                               visible={confirmvisible}
                               onOk={() => {
                                   this.submitHandler('sub')
                               }}
                               confirmLoading={confirmLoading}
                               onCancel={this.handleCancel5}
                        >
                            <p>{"提交时根据产品线、税率拆分成多张单子，提交后将无法修改、删除订单，确认提交？"}</p>
                        </Modal>
                        <Button onClick={() => {
                            this.submitHandler('save')
                        }} disabled={!canSave}>保存</Button>
                        <Button onClick={this.goBack}>返回</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <div className="Card-p">
                            <Row>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>客户名称：</label>
                                            <span>{details.cusName}</span></p>
                                        <p><label>客户编号：</label>
                                            <span>{details.cusNumber}</span></p>
                                        <p><label>退货日期：</label>
                                            <span>{new Date().format('yyyy-MM-dd')}</span></p>
                                        <p><label>退货类型：</label>
                                            <span>商务退货</span></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label className="ant-form-item-required">购货单位：</label>
                                            {
                                                purchaseUnitList.length > 0 ? <Select value={formData.purchaseUnit}
                                                                                      style={{width: '180px'}}
                                                                                      dropdownMatchSelectWidth={false}
                                                                                      onChange={(value) => {
                                                                                          this.changeSelect(value, 'purchaseUnit')
                                                                                      }}>
                                                    {purchaseUnitList.map(item =>
                                                        <Select.Option key={item.id}
                                                                       value={item.id.toString()}>{item.name}</Select.Option>
                                                    )}
                                                </Select> : null
                                            }</p>
                                        <p><label>签约类型：</label>
                                            <span>{details.contractType || '-'}</span></p>
                                        {/*<p><label className="ant-form-item-required">税率：</label>
                                            <Select value={formData.taxRate} style={{width: '210px'}}
                                                    onChange={(value) => {
                                                        this.changeSelect(value, 'taxRate')
                                                    }}>
                                                {this.taxRateOptions.map(item => <Select.Option key={item.id}
                                                                                                value={item.id}>{item.text}</Select.Option>)}
                                            </Select></p>*/}
                                        <p><label className="ant-form-item-required">退货相关类型：</label>
                                            <Select value={formData.returnRelatedTypes}
                                                    style={{width: '154px'}}
                                                    onChange={(value) => {
                                                        this.changeSelect(value, 'returnRelatedTypes')
                                                    }}>
                                                {this.returnRelatedTypesList.map(item => <Select.Option key={item.id}
                                                                                                        disabled={item.isDisabled}
                                                                                                        value={item.id}>{item.text}</Select.Option>)}
                                            </Select></p>
                                        <p><label className="ant-form-item-required">退货细分类型：</label>
                                            <Select value={formData.returnDetailType}
                                                    style={{width: '154px'}}
                                                    onChange={(value) => {
                                                        this.changeSelect(value, 'returnDetailType')
                                                    }}>
                                                {returnDetailTypes.map(item => <Select.Option key={item.text}
                                                                                              value={item.text}>{item.text}</Select.Option>)}
                                            </Select></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label className="ant-form-item-required">退货地点：</label>
                                            {
                                                returnAddressList.length > 0 ? <Select value={formData.returnAddress}
                                                                                       style={{width: 150}}
                                                                                       onChange={(value) => {
                                                                                           this.changeSelect(value, 'returnAddress')
                                                                                       }}>
                                                    {returnAddressList.map(item =>
                                                        <Select.Option key={item.gobackAddressId}
                                                                       value={item.gobackAddressId.toString()}>{item.gobackAddress}</Select.Option>
                                                    )}
                                                </Select> : null
                                            }</p>
                                        <p><Tooltip
                                            title="选取不到？请到菜单‘事物管理-库存’->‘子库存管理’->‘新增’"><label
                                            className="ant-form-item-required">退货子库：</label></Tooltip>
                                            {
                                                returnSubbankList.length > 0 ?
                                                    <Select
                                                        value={formData.returnSubbank}
                                                        style={{width: 150}}
                                                        onChange={(value) => {
                                                            this.changeSelect(value, 'returnSubbank')
                                                        }}>
                                                        {returnSubbankList.map(item =>
                                                            <Select.Option key={item.id}
                                                                           value={item.id.toString()}>{item.subStoreName}</Select.Option>
                                                        )}
                                                    </Select> : <Button icon="plus"
                                                                        onClick={this.goView.bind(this, `/subStock/add`)}>点击创建子库</Button>
                                            }</p>
                                        <p><label className="ant-form-item-required">退货原因：</label>
                                            {
                                                returnReasonList.length > 0 ? <Select value={formData.returnReason}
                                                                                      style={{width: '150px'}}
                                                                                      onChange={(value) => {
                                                                                          this.changeSelect(value, 'returnReason')
                                                                                      }}>
                                                    {returnReasonList.map(item =>
                                                        <Select.Option key={item.id}
                                                                       value={item.sKey}>{item.name}</Select.Option>
                                                    )}
                                                </Select> : null
                                            }</p>
                                        <p><label className="ant-form-item-required">联系电话：</label>
                                            <Input name="contactNumber" value={formData.contactNumber}
                                                   style={{width: 150}}
                                                   onChange={(e) => this.changeInput(e)}/></p>
                                    </Card>
                                </Col>
                                <Col span={6}>
                                    <Card bordered={false} noHovering={true}>
                                        <p><label>年度销售总额：</label>
                                            <span>{details.yearRrturnAmount || '-'}</span></p>
                                        <p><label>年度退货总额：</label>
                                            <span>{details.yearGobackAmount || '-'}</span></p>
                                        <p><label>本次退货数量：</label>
                                            <span>{formData.returnNumber || '-'}</span></p>
                                        <p><label>本次退货金额：</label>
                                            <span>{formData.curArturnAmount || '-'}</span></p>
                                        <p><label>实际退货金额：</label>
                                            <span>{formData.actualReturnAmount == '' ? formData.curArturnAmount : formData.actualReturnAmount || '-'}</span>
                                        </p>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div>
                    <DmsTab className="white-bg no-border"
                            options={['退货物料（网上退货只允许查到2年内发货的产品，超2年无法退货的请联系对应区域的物流退货员沟通处理）']}
                            defaultKey={0}/>
                    <div className="dms-table-box">
                        <div style={{marginBottom: 8}}>
                            <Button onClick={this.addHandler}>新增行</Button>
                            <Button onClick={this.deleteHandler} style={{marginLeft: 10}}>删除行</Button>
                        </div>
                        <Table {...tableViewProps} bordered rowSelection={rowSelection}/>
                    </div>
                </div>

                <Modal
                    visible={visible}
                    title={<span>选择物料<span style={{'color': 'red'}}>（不同成套项目编码请分开退货）</span></span>}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                    width={'80%'}
                >
                    <div>
                        <Row>
                            <Col span={4}><label>物料编码：</label><Input style={{width: 100}} value={searchObj.objCode}
                                                                         onChange={(e) => {
                                                                             this.changeSearchObj(e, 'objCode')
                                                                         }}/></Col>
                            <Col span={6}><label>物料名称：</label><Input style={{width: 200}}
                                                                         value={searchObj.objDescription}
                                                                         onChange={(e) => {
                                                                             this.changeSearchObj(e, 'objDescription')
                                                                         }}/></Col>
                            {/*<Col span={4}><label>中类：</label><Input style={{width: 100}} value={searchObj.middleCat}*/}
                            {/*                                         onChange={(e) => {*/}
                            {/*                                             this.changeSearchObj(e, 'middleCat')*/}
                            {/*                                         }}/></Col>*/}
                            <Col span={4}><label>出库单号：</label><Input style={{width: 100}}
                                                                         value={searchObj.stockCode}
                                                                         onChange={(e) => {
                                                                             this.changeSearchObj(e, 'stockCode')
                                                                         }}/></Col>
                            <Col span={4}><label>订单号：</label><Input style={{width: 100}} value={searchObj.orderCode}
                                                                       onChange={(e) => {
                                                                           this.changeSearchObj(e, 'orderCode')
                                                                       }}/></Col>
                            <Col span={4}><label>发票池ID：</label><Input style={{width: 100}} value={searchObj.lineId}
                                                                         onChange={(e) => {
                                                                             this.changeSearchObj(e, 'lineId')
                                                                         }}/></Col>
                            <Col span={2}><Button onClick={this.searchOrderList}>搜索</Button></Col>
                        </Row>
                        <Table {...addProps} bordered /*rowSelection={rowSelection1}*/ style={{marginTop: 10}}
                               pagination={pagination}/>
                    </div>
                </Modal>

            </div>
        )
    }
}
;
export default withRouter(BusinessAdd);



// WEBPACK FOOTER //
// ./src/routes/returnGoods/business.js